<template>
  <div class="svg" v-if="svg" v-html="svg" @mouseover="show" @mouseout="hide" />
    <label class="tooltip" v-if="tooltip" :style="{ top, left }">
    <h4>{{ tooltip.opcao }} {{ !tooltip.note ? '' : ' *' }}</h4>
    <span>Assentos: {{ tooltip.mandatos }}</span>
    <span>Votos: {{ numbers(tooltip.votos) }}</span>
  </label>
</template>

<script>
import parliamentSVG from "parliament-svg";
import { toHtml } from "hast-util-to-html";
import { numbers } from "@/core/utils";
import utils from "@/widgets/eleicoes/partidos";

export default {
    props: {
        data: Array,
        order: Array,
        total: {
        default: 230,
        type: Number,
        },
    },
    data: () => ({
        tooltip: null,
        svg: null,
        left: -1,
        top: -1,
        res: {},
        clear: null,
        seated: 0,
    }),
    mounted() {
        document.addEventListener("mousemove", this.cursor);
        window.addEventListener("scroll", this.scroll);
    },
    methods: {
        numbers,
        show(event) {
        clearTimeout(this.clear);
        if (
            !event ||
            !event.target ||
            !event.target.tagName ||
            event.target.tagName != "circle"
        )
            return;
        const id = event.target.getAttribute("class");
        if (!id) return;
        this.tooltip = this.res[id];
        },
        hide() {
            clearTimeout(this.clear);
            this.clear = setTimeout(() => (this.tooltip = null), 5);
        },
        cursor(event) {
            this.left = event.clientX + "px";
            this.top = event.clientY + "px";
        },
        render() {
            const data = [...(this.data || [])];
            let seats = {};
            let seated = 0;
            let temp = {};
            let other = [];
            data.forEach((item) => {
                const slug = utils.partify(item.opcao);
                !this.order.includes(slug) && !other.includes(slug) && other.push(slug);
                temp[slug] = {
                    seats: parseInt(item.mandatos),
                    colour: utils.cor(item.opcao)
                };
                seated += temp[slug].seats;
                this.res[slug] = item;
            });
            const remaining = seated < this.total ? this.total - seated : 0;
            temp.restantes = {
                seats: remaining,
                colour: "#cfd6d0"
            };
            [...(this.order || []), ...other].forEach(
                (slug) => temp[slug] && (seats[slug] = temp[slug])
            );
            const graph = parliamentSVG(seats);
            this.svg = toHtml(graph);
            this.seated = seated;
        },
        scroll() {
            this.hide();
        }
    },
    watch: {
        data: {
            deep: true,
            immediate: true,
            handler() {
                this.render();
            },
        },
    },
    beforeUnmount() {
        document.removeEventListener("mousemove", this.cursor);
        window.removeEventListener("scroll", this.scroll);
        clearTimeout(this.clear);
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

label.tooltip {
    display: block;
    position: fixed;
    padding: 1rem;
    color: #fff;
    background: rgba(0, 0, 0, 0.75);
    z-index: 100;
    font-size: 0.8rem;
    text-align: left;
    @include radius(5px);
    h4 {
        color: #fff;
    }
    > * {
        display: block;
        margin: 0;
        padding: 0;
	}
	@include medium(true){
		display: none;
	}
}
.svg {
}
</style>
